import {mapActions} from 'vuex'

export const filterSidebarList = {
  data() {
    return {
      nameList: [],
      provinceList: [],
      districtList: [],
      filter: {
        nameSelected: [],
        provinceSelected: [],
        districtSelected: []
      },
      filterMap: {},
      countOpenFilterPanel: 0
    }
  },
  computed: {
    nameSelected() {
      return this.filter.nameSelected
    },
    provinceSelected() {
      return this.filter.provinceSelected
    },
    districtSelected() {
      return this.filter.districtSelected
    }
  },
  methods: {
    ...mapActions('common', ['getLocationAndZoneTypeList']),
    initData() {
      if (Object.prototype.hasOwnProperty.call(localStorage, 'provinceList'))
        this.provinceList = JSON.parse(localStorage.getItem('provinceList'))
      if (Object.prototype.hasOwnProperty.call(localStorage, 'districtList'))
        this.districtList = JSON.parse(localStorage.getItem('districtList'))
    },
    mapFilter(_filterItem, _key) {
      this.filterMap[_key] = []
      _filterItem.forEach(item => {
        this.filterMap[_key].push(item['id'])
      })
      if (!this.filterMap[_key].length) {
        delete this.filterMap[_key]
      }
    },
    async getUserListWhenOpenSidebar() {
      if (this.countOpenFilterPanel === 0) {
        if (['district', 'commune'].includes(this.pathName)) {
          await this.getLocationAndZoneTypeList()
        }
      }
      if (['district', 'commune'].includes(this.pathName)) {
        this.initData()
      }
      this.countOpenFilterPanel++
    },
    resetCondition() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = []
      })
      this.nameList = []
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        id: newTag
      }
      this.nameList.push(tag)
      this.filter.nameSelected.push(tag)
    }
  },
  watch: {
    nameSelected(value) {
      this.mapFilter(value, 'names')
    },
    provinceSelected(value) {
      this.mapFilter(value, 'province_ids')
      this.$emit('onChangeMultiSelect', this.filterMap['province_ids'] ? this.filterMap['province_ids'].length : null)
    },
    districtSelected(value) {
      this.mapFilter(value, 'district_ids')
      this.$emit('onChangeMultiSelect', this.filterMap['district_ids'] ? this.filterMap['district_ids'].length : null)
    }
  }
}
